import React, { createContext, useCallback, useContext, useEffect, useState } from 'react'
import { Modal } from '@mui/material'
import Box from '@mui/material/Box'
import SidebarHelper from '../SidebarHelper/SidebarHelper'

type ModalWithSidebarProps = {
	children: React.ReactNode
	show: boolean
}

const getModalStyle = (sidebarOpen: boolean) => ({
	position: 'absolute',
	top: '50%',
	left: sidebarOpen ? '40%' : '50%',
	transform: 'translate(-50%, -50%)',
	width: '800px',
	maxHeight: '85%',
	backgroundColor: 'background.paper',
	overflow: 'auto',
	p: 4,
	boxShadow: 24,
	borderRadius: 2,
	outline: 'none',
})

const SIDEBAR_DEFAULT_OPEN = true

const ModalWithSidebarContext = createContext<{ openSidebar: () => void }>({} as any)

export default function ModalWithSidebarProvider({ children, show }: ModalWithSidebarProps) {
	const [open, setOpen] = useState(show)

	const [sidebarOpen, setSidebarOpen] = useState<boolean>(() => {
		if (localStorage.getItem('sidebar_helper_open') === 'close') return false
		return SIDEBAR_DEFAULT_OPEN
	})

	useEffect(() => setOpen(show), [show])

	const handleOnChange = useCallback((state: boolean) => {
		localStorage.setItem('sidebar_helper_open', 'close')
		setSidebarOpen(state)
	}, [])

	const openSidebar = useCallback(() => setSidebarOpen(true), [])

	return (
		<ModalWithSidebarContext.Provider value={{ openSidebar }}>
			<Modal open={open}>
				<React.Fragment>
					<Box sx={getModalStyle(sidebarOpen)}>{children}</Box>
					<SidebarHelper onChange={handleOnChange} show={sidebarOpen} accordionDefaultOpen="answer_0" />
				</React.Fragment>
			</Modal>
		</ModalWithSidebarContext.Provider>
	)
}

export const useShowSidebar = () => useContext(ModalWithSidebarContext)
